import LiveNewOrderModal from "@/Pages/Auth/Bestellingen/Live/LiveNewOrderModal";
import useLiveOrdersHook from "@/Pages/Auth/Bestellingen/Live/useLiveOrdersHook";
import { useLocation } from "react-router-dom";

const NewOrdersModal = () => {
  const { pathname } = useLocation();
  const paths = ["/orders/live", "/orders/pos-order"];
  const orders = useLiveOrdersHook();

  if (paths.includes(pathname)) {
    return <LiveNewOrderModal data={orders} />;
  }
};

export default NewOrdersModal;
